import { useSetSearchParams } from '@hook/useSetSearchParams';
import Select, { type DropdownIndicatorProps, type StylesConfig } from 'react-select';

export interface ISelect {
    serverId: string;
    serverName: string;
}

export interface SelectOption {
    label: string;
    value: string;
}

const SelectBox = ({
    selectList,
    activeSelectId,
    paramKey,
}: {
    selectList: SelectOption[] | undefined;
    activeSelectId: string | null;
    paramKey: string;
}) => {
    const setParams = useSetSearchParams();
    const onChange = (value: string | undefined) => value && setParams({ [paramKey]: value });

    if (!selectList) return null;
    return (
        <div className="w-[calc(100%-48px)] lg:w-[auto]">
            <Select
                options={selectList}
                menuPlacement={'auto'}
                value={selectList?.filter((option) => option.value === activeSelectId?.toString())}
                onChange={(option) => onChange((option as SelectOption).value)}
                isSearchable={false}
                styles={customStyles}
                components={{ DropdownIndicator }}
            />
        </div>
    );
};

export default SelectBox;
const DropdownIndicator = (props: DropdownIndicatorProps) => {
    return null;
};
const customStyles: StylesConfig = {
    option: (baseStyles, state) => ({
        ...baseStyles,
        paddingTop: '9px',
        paddingBottom: '12px',
        color: state.isDisabled ? 'var(--rk-select-disabled)' : state.isSelected ? 'var(--ncui-black093)' : 'var(--ncui-black093)',
        backgroundColor: state.isDisabled ? 'var(--ncui-gray004-hex)' : state.isSelected ? 'var(--ncui-bg)' : 'var(--ncui-gray004-hex)',
        borderBottom: '1px solid var(--ncui-gray012)',
        borderLeft: '1px solid var(--ncui-gray012)',
        borderRight: '1px solid var(--ncui-gray012)',
        cursor: state.isDisabled ? 'default' : 'pointer',
        '&:hover': {
            color: state.isDisabled ? 'var(--rk-select-disabled)' : state.isSelected ? 'var(--ncui-black093)' : 'var(--ncui-point-text)',
        },
    }),
    control: (baseStyles) => ({
        ...baseStyles,
        color: 'var(--ncui-black093)',
        backgroundColor: 'var(--ncui-bg)',
        borderColor: 'var(--ncui-gray012)',
        boxShadow: 'none',
        minWidth: '60px',
        fontSize: '15px',
        minHeight: '20px',
        borderRadius: 'none',
        borderStyle: 'none',
        '&:hover': {
            borderColor: 'var(--ncui-gray012)',
        },
    }),
    menu: (baseStyles) => ({
        ...baseStyles,
        marginTop: 0,
        borderRadius: 'none',
        boxShadow: 'none',
        borderTop: '1px solid var(--ncui-gray012-hex)',
        borderBottom: '1px solid var(--ncui-gray012-hex)',
    }),
    menuList: (baseStyles) => ({
        ...baseStyles,
        padding: 0,
        fontSize: '15px',
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: 'var(--ncui-black093)',
        backgroundColor: 'var(--ncui-bg)',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
};
